// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__38jbR","errorLogs":"EditorFooter_errorLogs__1kXJj"};